import React from 'react';
import { Box, Container, Typography, Grid, Paper } from '@mui/material';
import { motion } from 'framer-motion';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import AssessmentIcon from '@mui/icons-material/Assessment';
import InventoryIcon from '@mui/icons-material/Inventory2';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import ReceiptIcon from '@mui/icons-material/Receipt';
import NotificationsIcon from '@mui/icons-material/Notifications';
import StorefrontIcon from '@mui/icons-material/Storefront';
import DevicesIcon from '@mui/icons-material/Devices';

const areas = [
  {
    icon: <InventoryIcon sx={{ fontSize: 32 }} />,
    title: 'Control de Inventario',
    desc: 'Stock en tiempo real, alertas de bajo inventario, precios de costo y venta.',
  },
  {
    icon: <PeopleAltIcon sx={{ fontSize: 32 }} />,
    title: 'Gestión de Clientes',
    desc: 'Historial completo de cada cliente, sus servicios, compras y comunicaciones.',
  },
  {
    icon: <ReceiptIcon sx={{ fontSize: 32 }} />,
    title: 'Facturación y Cotizaciones',
    desc: 'Generación de presupuestos, conversión a facturas y control de pagos.',
  },
  {
    icon: <PointOfSaleIcon sx={{ fontSize: 32 }} />,
    title: 'Control de Ingresos y Gastos',
    desc: 'Registro financiero, gráficas de rentabilidad y exportación a Excel.',
  },
  {
    icon: <CalendarMonthIcon sx={{ fontSize: 32 }} />,
    title: 'Agendas y Reservas',
    desc: 'Programación de citas, turnos y recordatorios automáticos para clientes.',
  },
  {
    icon: <AssessmentIcon sx={{ fontSize: 32 }} />,
    title: 'Reportes y Dashboards',
    desc: 'Visualización de métricas clave del negocio en tiempo real.',
  },
  {
    icon: <NotificationsIcon sx={{ fontSize: 32 }} />,
    title: 'Notificaciones Automáticas',
    desc: 'Alertas por WhatsApp, correo o SMS para clientes y administradores.',
  },
  {
    icon: <StorefrontIcon sx={{ fontSize: 32 }} />,
    title: 'Punto de Venta',
    desc: 'Registro de ventas, control de caja y cierre diario automatizado.',
  },
  {
    icon: <AutoFixHighIcon sx={{ fontSize: 32 }} />,
    title: 'Automatización de Procesos',
    desc: 'Eliminamos tareas manuales y repetitivas que consumen tiempo de tu equipo.',
  },
  {
    icon: <DevicesIcon sx={{ fontSize: 32 }} />,
    title: 'Solución a Medida',
    desc: 'Si tu negocio necesita algo específico que no está aquí, lo construimos.',
  },
];

const AutomationSection = () => {
  return (
    <Box id="services" sx={{ bgcolor: '#F4F4F5', py: { xs: 8, md: 12 } }}>
      <Container maxWidth="lg">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <Typography
            variant="overline"
            display="block"
            align="center"
            sx={{ color: '#38BDF8', fontWeight: 700, letterSpacing: 3, mb: 1 }}
          >
            QUÉ AUTOMATIZAMOS
          </Typography>
          <Typography
            variant="h3"
            align="center"
            sx={{ fontWeight: 800, color: '#083a94', mb: 2, fontSize: { xs: '2rem', md: '2.6rem' } }}
          >
            Tu negocio, digitalizado
          </Typography>
          <Typography
            align="center"
            sx={{ color: '#555', maxWidth: 580, mx: 'auto', mb: 8, fontSize: '1.05rem' }}
          >
            Estas son las áreas que más automatizamos en pequeños negocios.
            Si la tuya no aparece aquí, igual podemos ayudarte.
          </Typography>
        </motion.div>

        <Grid container spacing={2.5} columns={12}>
          {areas.map((area, i) => (
            <Grid key={area.title} span={{ xs: 12, sm: 6, md: 4, lg: 4 }}>
              <motion.div
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.45, delay: (i % 3) * 0.1 }}
                style={{ height: '100%' }}
              >
                <Paper
                  elevation={0}
                  sx={{
                    p: 3.5,
                    height: '100%',
                    border: '1px solid #E5E7EB',
                    borderRadius: 3,
                    bgcolor: 'white',
                    transition: 'box-shadow 0.3s, transform 0.3s, border-color 0.3s',
                    '&:hover': {
                      boxShadow: '0 8px 32px rgba(8,58,148,0.1)',
                      transform: 'translateY(-3px)',
                      borderColor: '#38BDF8',
                    },
                  }}
                >
                  <Box
                    sx={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: 56,
                      height: 56,
                      borderRadius: 2,
                      bgcolor: 'rgba(8,58,148,0.07)',
                      color: '#083a94',
                      mb: 2,
                    }}
                  >
                    {area.icon}
                  </Box>
                  <Typography variant="h6" sx={{ fontWeight: 700, color: '#083a94', mb: 1, fontSize: '1rem' }}>
                    {area.title}
                  </Typography>
                  <Typography sx={{ color: '#666', fontSize: '0.9rem', lineHeight: 1.6 }}>
                    {area.desc}
                  </Typography>
                </Paper>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default AutomationSection;
